import fileDownload from "js-file-download";
import * as moment from "moment";
import {
    CONSULTAR_HISTORICO_REPUESTA,
    DESCARGAR_XLS_HISTORICO,
    HISTORICO_RESPUESTA_CONSULTADOS,
    ERROR_CONSULTANDO_HISTORICO_RESPUESTA,
    EXITO_DESCARGAR_RESPUESTAS_XLS,
    ERROR_DESCARGAR_RESPUESTAS_XLS,
    historicoRespuestaConsultados,
    errorConsultandoHistoricoRespuesta,
    exitoDescargarRespuestasXLS,
    errorDescargarRespuestasXLS
} from "./historicoRespuestaActions";
import { AnyAction } from "redux";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { FiltroConsultaHistorico } from "../modelo/ReporteHistoricoModelo";
import { errorAutorizacion } from "../../../../inicio/modulos/inicioActions";

export const consultarHistoricoRespuestaEpic = action$ =>
    action$.ofType(CONSULTAR_HISTORICO_REPUESTA)
        .mergeMap((action: any) => {

            const url = `sat/consultar/historico-repuesta-sat?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return historicoRespuestaConsultados(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoHistoricoRespuesta()];
                });
        });

export const descargarXLSHistoricoEpic = action$ =>
        action$.ofType(DESCARGAR_XLS_HISTORICO)
            .mergeMap((action: any) => {
    
                const url = `sat/consultar/historico-repuesta-sat-xls?${obtenerFiltroConsulta(action.filtro)}`;
    
                return authenticatedAjax
                    .getBlob(url)
                    .map((response) => {
                        const data = response.response;
                        fileDownload(
                            data,
                            `RESPUESTAS_SAT_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`,
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        );
                        return exitoDescargarRespuestasXLS();
                    }).catch(response =>
                        [errorDescargarRespuestasXLS()]
                    );
            });

export const historicoRespuestaReducer = (state = {
    estado: REQUEST.NONE,
    estadoDescarga: REQUEST.NONE,
    datosRespuesta: [],
    paginas: 0,
    totalPeriodosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_HISTORICO_REPUESTA:
            return {
                ...state,
                estado: REQUEST.PENDING,
                datosRespuesta: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalPeriodosConsulta: 0,
                paginaActual: action.filtro.paginaActual,
                showAlert: false
            };
        case DESCARGAR_XLS_HISTORICO:
            return {
                ...state,
                estadoDescarga: REQUEST.PENDING
            };
        case EXITO_DESCARGAR_RESPUESTAS_XLS:
        case ERROR_DESCARGAR_RESPUESTAS_XLS:
                return {
                    ...state,
                    estadoDescarga: REQUEST.SUCCESS
                };
        case HISTORICO_RESPUESTA_CONSULTADOS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                datosRespuesta: action.datosRespuesta,
                paginas: action.paginas,
                totalPeriodosConsulta: action.totalDatos,
                showAlert: false
            };
        case ERROR_CONSULTANDO_HISTORICO_RESPUESTA:
            return {
                ...state,
                estado: REQUEST.ERROR,
                datosRespuesta: [],
                paginas: 0,
                totalPeriodosConsulta: 0,
                showAlert: false
            };
        default:
            return state;
    }
};



const obtenerFiltroConsulta = (filtro: FiltroConsultaHistorico) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.tipoTransaccion) params.set('tipoTransaccion', filtro.tipoTransaccion.toString());
        if (filtro.dniEmpleador) params.set('dniEmpleador', filtro.dniEmpleador);
        if (filtro.poliza) params.set('poliza', filtro.poliza);
        if (filtro.consecutivo) params.set('consecutivo', filtro.consecutivo.toString());
        if (filtro.codigoSede) params.set('codigoSede', filtro.codigoSede);
        if (filtro.codigoCentroTrabajo) params.set('codigoCentroTrabajo', filtro.codigoCentroTrabajo);
        if (filtro.dniEmpleado) params.set('dniEmpleado', filtro.dniEmpleado);
        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');

    }

    return params.toString();
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_historico_rta/modulos/historicoRespuestaReducers.ts